import {
  BrowserPlugin,
  BrowserOpenOptions,
  BrowserPrefetchOptions,
  PluginListenerHandle,
} from '@absis/core-plugins';
let lastWindow: any;
export class BrowserPluginWeb implements BrowserPlugin {
  constructor() {
    lastWindow = null;
  }
  async open(options: BrowserOpenOptions): Promise<void> {
    lastWindow = window.open(
      options.url,
      options.windowName || '_blank',
      'noopener,noreferrer'
    );
    return Promise.resolve();
  }

  async prefetch(_options: BrowserPrefetchOptions): Promise<void> {
    // Does nothing
    return Promise.resolve();
  }

  async close() {
    lastWindow && lastWindow.close();
    return Promise.resolve();
  }

  addListenerBrowserFinished(): PluginListenerHandle {
    return {
      remove: () => undefined,
    };
  }
  addListenerBrowserPageLoaded(): PluginListenerHandle {
    return {
      remove: () => undefined,
    };
  }
  removeAllListeners(): void {
    throw new Error('Method not implemented.');
  }
}

const CBBrowser = new BrowserPluginWeb();

export { CBBrowser };
